// GENERATED FILE - DO NOT EDIT

// This file has been automatically generated. Any modifications made to this file will be overwritten the next time it is regenerated. Please refrain from editing this file directly.

/** Luxembourg */
const LU = /^(?:6(?:[26][18]|5[1568]|7[189]|81|9[128])\d{6})$/;

export default LU;
